import featureConstants from '../../constants/featureConstants';
import { isFeatureActive } from '../../redux/reducers/config/configReducer';

const isPayPalAvailable = state => !isFeatureActive(state, featureConstants.DISABLE_PAYPAL);

export default isPayPalAvailable;
